import { LOCALE } from 'src/providers/types';
import { languageMessages } from 'src/utils/messages';

export const languageOptions = {
    [LOCALE.BG]: languageMessages.bulgarian,
    [LOCALE.EN]: languageMessages.english,
};
